export default __webpack_public_path__ + "static/media/Trustpilot_circle.d98fb5c9.svg";